import { type Component } from 'vue';
import { Calendar, CircleDot, DollarSign, FileText, Hash, List, MapPin, Percent, Type } from 'lucide-vue-next';
import type { CustomFieldType } from '@/api/entity_types/CustomField';

type FieldType = {
  key: CustomFieldType;
  label: string;
  icon: Component;
  hasOptions: boolean;
};

const fieldTypes: FieldType[] = [
  { key: 'short_text', label: 'Text', icon: Type, hasOptions: false },
  { key: 'single_option', label: 'Single option', icon: CircleDot, hasOptions: true },
  { key: 'multiple_options', label: 'Multiple options', icon: List, hasOptions: true },
  { key: 'date', label: 'Date', icon: Calendar, hasOptions: false },
  { key: 'number', label: 'Number', icon: Hash, hasOptions: false },
  { key: 'percentage', label: 'Percentage', icon: Percent, hasOptions: false },
  { key: 'currency', label: 'Currency', icon: DollarSign, hasOptions: false },
  { key: 'rich_text', label: 'Rich text', icon: FileText, hasOptions: false },
  { key: 'address', label: 'Address', icon: MapPin, hasOptions: false },
];

export const list = (): FieldType[] => [...fieldTypes];

export const find = (key: CustomFieldType): FieldType =>
  fieldTypes.find(fieldType => fieldType.key === key) ?? fieldTypes[0];
